export const getShops = state => state.shop.shops;

export const getShopsByPartnerId = (state, partnerId) => {
    if (partnerId) {
        const shops = getShops(state);
        return shops[partnerId] ? shops[partnerId] : [];
    }
    return null;
};



// WEBPACK FOOTER //
// ./src/services/shop/selector.js